import React from "react";
import styles from "./singleperson.module.scss";
import { SonicSNSFollowers } from "../../common/classes/SonicSNSFollowers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SinglePersonTitle from "./SinglePersonTitle";

type Props = {
  isLoading: boolean;
  followersData: SonicSNSFollowers | null | undefined;
  instagramLink?: string;
  youtubeLink?: string;
  twitchLink?: string;
};
const SNSFollowers: React.FC<Props> = ({
  isLoading,
  followersData,
  instagramLink,
  youtubeLink,
  twitchLink,
}) => {
  return (
    <div className={styles["introduction__item"]}>
      <SinglePersonTitle title={"FOLLOWERS"} subTitle={"SNSフォロワー"} />
      <div className={styles["introduction__item__contents"]}>
        <ul className={styles["introduction__followers"]}>
          {(followersData?.twitter || isLoading) && (
            <li
              className={`${styles["introduction__followers__item"]} ${styles["twitter"]}`}
            >
              <span className={styles["introduction__followers__icon"]}>
                <FontAwesomeIcon icon={["fab", "x-twitter"]} />
              </span>
              <span className={styles["introduction__followers__number"]}>
                {followersData?.twitter || "-"}
              </span>
            </li>
          )}

          {(followersData?.instagram || isLoading) && (
            <li
              className={`${styles["introduction__followers__item"]} ${styles["instagram"]}`}
            >
              {instagramLink ? (
                <a
                  href={instagramLink}
                  target="_blank"
                  className={styles["introduction__followers__link"]}
                  rel="noopener noreferrer"
                >
                  <span className={styles["introduction__followers__icon"]}>
                    <FontAwesomeIcon icon={["fab", "instagram"]} />
                  </span>
                  <span className={styles["introduction__followers__number"]}>
                    {followersData?.instagram || "-"}
                  </span>
                </a>
              ) : (
                <>
                  <span className={styles["introduction__followers__icon"]}>
                    <FontAwesomeIcon icon={["fab", "instagram"]} />
                  </span>
                  <span className={styles["introduction__followers__number"]}>
                    {followersData?.instagram || "-"}
                  </span>
                </>
              )}
            </li>
          )}

          {(followersData?.youtube || isLoading) && (
            <li
              className={`${styles["introduction__followers__item"]} ${styles["youtube"]}`}
            >
              {youtubeLink ? (
                <a
                  href={youtubeLink}
                  target="_blank"
                  className={styles["introduction__followers__link"]}
                  rel="noopener noreferrer"
                >
                  <span className={styles["introduction__followers__icon"]}>
                    <FontAwesomeIcon icon={["fab", "youtube"]} />
                  </span>
                  <span className={styles["introduction__followers__number"]}>
                    {followersData?.youtube || "-"}
                  </span>
                </a>
              ) : (
                <>
                  <span className={styles["introduction__followers__icon"]}>
                    <FontAwesomeIcon icon={["fab", "youtube"]} />
                  </span>
                  <span className={styles["introduction__followers__number"]}>
                    {followersData?.youtube || "-"}
                  </span>
                </>
              )}
            </li>
          )}

          {(followersData?.twitch || isLoading) && (
            <li
              className={`${styles["introduction__followers__item"]} ${styles["twitch"]}`}
            >
              {twitchLink ? (
                <a
                  href={twitchLink}
                  target="_blank"
                  className={styles["introduction__followers__link"]}
                  rel="noopener noreferrer"
                >
                  <span className={styles["introduction__followers__icon"]}>
                    <FontAwesomeIcon icon={["fab", "twitch"]} />
                  </span>
                  <span className={styles["introduction__followers__number"]}>
                    {followersData?.twitch || "-"}
                  </span>
                </a>
              ) : (
                <>
                  <span className={styles["introduction__followers__icon"]}>
                    <FontAwesomeIcon icon={["fab", "twitch"]} />
                  </span>
                  <span className={styles["introduction__followers__number"]}>
                    {followersData?.twitch || "-"}
                  </span>
                </>
              )}
            </li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default SNSFollowers;
